import React, { useEffect, useState } from "react";
import { X, Copy, Check, Gift } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import { img } from "../lib/api";

const KEY = "bb_popup_seen";

const PromoPopup = () => {
  const { settings, loading } = useSite();
  const { pathname } = useLocation();
  const p = settings?.popup;
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const sig = `${p?.title}|${p?.code}`;

  useEffect(() => {
    if (loading || !p?.enabled || pathname !== "/" || sessionStorage.getItem(KEY) === sig) return;
    const t = setTimeout(() => setOpen(true), (Number(p.delaySeconds) || 0) * 1000);
    return () => clearTimeout(t);
  }, [loading, p, pathname, sig]);

  if (!open) return null;
  const close = () => { sessionStorage.setItem(KEY, sig); setOpen(false); };
  const copy = () => { navigator.clipboard.writeText(p.code); setCopied(true); setTimeout(() => setCopied(false), 1600); };
  const shop = () => { close(); document.getElementById("products")?.scrollIntoView({ behavior: "smooth" }); };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 backdrop-blur-md p-4" onClick={close} data-testid="promo-popup">
      <div className="pop-in glass-gold-card max-w-md w-full rounded-3xl overflow-hidden relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={close} data-testid="promo-popup-close" className="absolute top-3 right-3 z-10 h-9 w-9 rounded-full bg-navy/70 text-slate-200 hover:text-gold flex items-center justify-center transition-colors"><X size={18} /></button>
        {p.image && <img src={img(p.image)} alt="" className="w-full h-44 object-cover" />}
        <div className="p-8 text-center">
          {!p.image && <div className="h-14 w-14 mx-auto mb-4 rounded-2xl bg-gold/15 border border-gold/40 flex items-center justify-center text-gold"><Gift size={26} /></div>}
          <h3 className="text-2xl font-bold liquid-gold-text" data-testid="promo-popup-title">{p.title}</h3>
          <p className="text-slate-300 mt-3 text-sm leading-relaxed">{p.text}</p>
          {p.code && (
            <button onClick={copy} data-testid="promo-popup-copy-code" className="mt-6 w-full inline-flex items-center justify-between border-2 border-dashed border-gold/60 rounded-xl px-5 py-3 text-gold font-bold tracking-[0.2em] hover:bg-gold/10 transition-colors">
              {p.code} {copied ? <Check size={18} /> : <Copy size={18} />}
            </button>
          )}
          <button onClick={shop} data-testid="promo-popup-cta" className="btn-liquid mt-4 w-full text-navy font-bold py-3.5 rounded-xl">{p.ctaText || "Shop Now"}</button>
        </div>
      </div>
    </div>
  );
};

export default PromoPopup;
